import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ProposalModel } from './models/proposals.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactsService } from 'src/app/pages/contacts/services/contacts.service';
import { debounceTime, distinctUntilChanged, finalize, map, switchMap, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ContactModel } from '../../../models/contacts.model';
import { LeadsModel } from 'src/app/pages/leads/models/leads.model';
import { LeadsService } from 'src/app/pages/leads/services/leads.service';
import { ProposalsService } from 'src/app/pages/proposals/services/proposals.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { DevelopmentsService } from '../../../services/developments.services';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { EventService } from 'src/app/core/services/event.service';
import { EntityService } from 'src/app/pages/entity/services/entity.service';
import { scheduleProposalsWindowUnlock } from '../../../services/proposals-window.util';
import { proposalHistoryObsLabelKey } from "src/app/pages/proposals/utils/proposal-history-obs-label.util";
import { SendToPromoterModalComponent } from "src/app/shared/modals/send-to-promoter/send-to-promoter-modal.component";

/** "Antes de aceitar": estados em que a proposta pode ir ao promotor (o servidor volta a verificar). */
const PROMOTER_EMAIL_OPEN_STATUSES = ['First Proposal', 'Counteroffer'];
/** Estado depois do envio: com ele no histórico a opção não volta a aparecer. */
const PROMOTER_UNDER_ANALYSIS_STATUS = 'Under Analysis';

@Component({
  selector: 'app-proposals-developments',
  templateUrl: './proposals.component.html',
  styleUrls: ['./proposals.component.scss']
})
export class ProposalsDevelopmentsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() property: any;
  @Input() propertyProposalsData!: ProposalModel[];
  // propertyProposalsData: ProposalModel[];
  proposalSelected!: ProposalModel | null;
  contactSelected: any;
  leadSelected: any;
  proposalForm!: FormGroup;
  counterProposalForm!: FormGroup;
  /**
   * Contacts Pagination
   */
  page: number = 1;
  pageSize: number = 5;
  startIndex: number = 1;
  endIndex: number = 5;
  filter: string = '';
  total = 0;
  /**
  * Leads Pagination
  */
  pageLeads: number = 1;
  pageSizeLeads: number = 5;
  startIndexLeads: number = 1;
  endIndexLeads: number = 5;
  totalLeads = 0;
  hideElement: boolean = false;
  contacts!: ContactModel[];
  leads!: LeadsModel[];
  subscription: Subscription = new Subscription();
  checkedList!: ContactModel[];
  queryField = new FormControl();
  clientNameBkp: any;
  noresult = false;
  noresultLeads = false;
  @Input()
  detailsForm: any;
  submited: boolean = false;
  submitedCounter: boolean = false;
  @Input() statusList!: any[];

  dirProposalsFiles = `${environment.apiUrl}/proposals/file/`;
  pathProfileImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;
  loginUser!: { id?: string, role?: { id?: string, name?: string }, stores?: any; };
  bkpList!: ProposalModel[];
  @Input() typeRent: any;
  @Input() agents!: any[];
  @Input() allAgents!: any[];
  @Input() openProposal!: any;
  pendingProposalsLimit: number | null = null;

  // --- horário de recebimento de propostas ---
  /**
   * Rascunho partilhado com o componente-pai. O horário é um campo do
   * formulário como outro qualquer: grava com o empreendimento, tanto na
   * criação como na edição. `startAt` a `undefined` significa que esta aba
   * nunca foi aberta e o valor guardado não deve ser tocado.
   */
  @Input() proposalsWindowDraftData: { startAt?: string | null } | null = null;
  proposalsWindow: any = null;
  private proposalsWindowTimer: any = null;
  /** Fuso da entidade, para mostrar a nota antes de existir imóvel. */
  entityTimezone: string | null = null;
  proposalsWindowEnabled = false;
  /** Hora de parede 'YYYY-MM-DD HH:mm'; o servidor converte-a com o fuso da entidade. */
  proposalsWindowDraft: string | null = null;

  @ViewChild('saleFormModal') saleFormModal: any;
  private proposalDetailsCache = new WeakMap<object, Array<{ label: string; value: any }>>();
  private proposalProposersCache = new WeakMap<object, any[]>();

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private contactsService: ContactsService,
    private leadsService: LeadsService,
    private proposalsService: ProposalsService,
    private translateService: TranslateService,
    private propertiesService: DevelopmentsService,
    public permissionsService: PermissionsService,
    private eventService: EventService,
    private entityService: EntityService,
  ) {
    // this.propertyProposalsData = this.getProposals();
  }

  ngOnInit(): void {
    this.agents = (this.agents ?? []).map(a => { return { ...a, isListing: a.isListingAgent, isSelling: a.isSellingAgent, listingCom: a.listingCommission, saleCom: a.saleCommission } });
    this.allAgents = (this.allAgents ?? []).map(a => { return { ...a, isListing: a.isListingAgent, isSelling: a.isSellingAgent, listingCom: a.listingCommission, saleCom: a.saleCommission } });
    const { id, role, stores } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores };
    this.propertyProposalsData = this.propertyProposalsData ?? [];
    this.bkpList = this.propertyProposalsData;
    this.loadPendingProposalsLimit();
    this.loadProposalsWindow();
    if (!this.isCreateMode) {
      this.searchData();
    }
  }

  ngAfterViewInit(): void {
    if (this.openProposal && !this.isCreateMode) {
      const find = this.propertyProposalsData.find(f => f.id == this.openProposal);
      if (find) {
        const el = document.getElementById(`proposal-${this.openProposal}`);
        if (el) {
          el.click();
        }
      }
      this.eventService.broadcast('clear-open-proposal');
    }
  }

  onChangestatus(event: any) {
    this.clearProposalDetailsCache();
    this.proposalSelected = null;
    if (event?.id) {
      this.propertyProposalsData = this.bkpList.filter(p => p?.history && p?.history[0]?.proposalStatusId === event.id)
    } else {
      this.propertyProposalsData = this.bkpList;
    }
  }

  searchData() {
    this.noresult = false;
    this.contacts = [];
    this.queryField.valueChanges
      .pipe(
        map(value => value.trim()),
        tap(val => this.filter = val),
        //filter(value => value.length > 1),
        debounceTime(200),
        distinctUntilChanged(),
        //tap(() => { this.store = this.agents[0].store; }),
        switchMap(value => this.contactsService.getAllCostumersWithOutProperty(this.property?.id, this.page, this.filter, [], [])),
        tap(data => this.total = data.total),
        map(data => data.costumers),
        tap(() => this.paginate()),
        tap(() => this.noresult = false)
      ).subscribe(contacts => {
        this.contacts = contacts;
        if (this.total === 0) {
          this.noresult = true;
        }
      });
  }

  /**
   * New Proposal
   */

  get form() {
    return this.proposalForm.controls;
  }

  newProposal(content: any) {
    if (this.proposalsWindow?.blocked) {
      return;
    }
    this.validateLimitAndOpenNewProposal(content);
  }

  // ---------------------------------------------------------------------------
  // Horário de recebimento de propostas
  // ---------------------------------------------------------------------------

  /**
   * Estamos a criar o empreendimento? Nesse caso a aba serve apenas para
   * definir o horário: não há propostas para listar nem para criar.
   */
  get isCreateMode(): boolean {
    return !this.property?.id;
  }

  /** Fuso a mostrar: do imóvel quando existe, senão o da entidade. */
  get proposalsWindowTimezone(): string | null {
    return this.proposalsWindow?.timezone ?? this.entityTimezone;
  }

  /** Só quem pode editar o empreendimento vê e mexe no horário. */
  get canEditDevelopment(): boolean {
    if (this.isCreateMode) {
      // Quem está a criar o empreendimento define o horário na criação.
      return this.permissionsService.canEditProperty(
        this.loginUser as any,
        this.property?.store?.id,
        true
      );
    }
    return (
      this.loginUser?.id === this.property?.mainAgent ||
      this.permissionsService.canEditProperty(
        this.loginUser as any,
        this.property?.store?.id
      ) ||
      this.permissionsService.checkAgentPermission(
        this.property?.mainAgent,
        'EDIT_PROPERTIES'
      )
    );
  }

  /**
   * Guarda a janela e agenda o desbloqueio para a hora de abertura, para que uma
   * página deixada aberta não fique presa em "Propostas a partir de ...".
   */
  private setProposalsWindow(data: any) {
    clearTimeout(this.proposalsWindowTimer);
    this.proposalsWindow = data ?? null;
    this.proposalsWindowTimer = scheduleProposalsWindowUnlock(
      this.proposalsWindow,
      () => (this.proposalsWindow = { ...this.proposalsWindow, blocked: false }),
    );
  }

  private loadProposalsWindow() {
    // Numa segunda visita a esta aba retoma-se o que já foi escolhido, para não
    // perder a escolha ao navegar entre abas.
    const pending = this.proposalsWindowDraftData?.startAt;
    if (pending !== undefined) {
      this.proposalsWindowDraft = pending;
      this.proposalsWindowEnabled = !!pending;
      if (this.isCreateMode) {
        return;
      }
    }

    if (this.isCreateMode) {
      this.syncProposalsWindowDraft();
      return;
    }

    this.subscription.add(
      this.propertiesService.getProposalsWindow(this.property.id).subscribe({
        next: (data) => {
          // Em edição o servidor dá o fuso e a etiqueta; o valor já escolhido
          // nesta sessão prevalece sobre o que está gravado.
          if (pending === undefined) {
            this.applyProposalsWindow(data);
          } else {
            this.setProposalsWindow(data);
          }
        },
      }),
    );
  }

  private applyProposalsWindow(data: any) {
    this.setProposalsWindow(data);
    this.proposalsWindowEnabled = !!data?.startAt;
    this.proposalsWindowDraft = data?.startAtWallClock ?? null;
    this.syncProposalsWindowDraft();
  }

  toggleProposalsWindow(enabled: boolean) {
    this.proposalsWindowEnabled = enabled;
    if (!enabled) {
      this.proposalsWindowDraft = null;
    }
    this.syncProposalsWindowDraft();
  }

  /**
   * O valor tem de vir do `$event`: com `[(ngModel)]` e um `(ngModelChange)`
   * próprio no mesmo elemento, a ordem dos dois listeners não é garantida e o
   * rascunho ficava uma alteração atrás — os minutos escolhidos perdiam-se e
   * ficava a hora cheia anterior.
   */
  onProposalsWindowDraftChange(value: string | null) {
    this.proposalsWindowDraft = value ?? null;
    this.syncProposalsWindowDraft();
  }

  /** O valor vive no rascunho do pai, gravado junto com o empreendimento. */
  syncProposalsWindowDraft() {
    if (!this.proposalsWindowDraftData) {
      return;
    }
    this.proposalsWindowDraftData.startAt = this.proposalsWindowEnabled
      ? this.proposalsWindowDraft
      : null;
  }

  private validateLimitAndOpenNewProposal(content: any) {
    if (!this.property?.id) {
      this.openNewProposalModal(content);
      return;
    }

    this.entityService.getEntityForProposal().subscribe({
      next: (entity) => {
        const limit = Number(entity?.pendingProposalsLimit ?? 0);
        this.pendingProposalsLimit = entity?.pendingProposalsLimit ?? null;

        if (!limit || limit <= 0) {
          this.openNewProposalModal(content);
          return;
        }

        this.propertiesService.getBy(this.property.id).subscribe({
          next: (propertyData) => {
            const proposals = propertyData?.proposals ?? [];
            const activeProposals = this.getActiveProposalsCount(proposals);
            if (activeProposals >= limit) {
              this.proposalLimitMsg(this.getLimitReachedMessage());
              return;
            }

            this.clearProposalDetailsCache();
            this.propertyProposalsData = proposals;
            this.bkpList = proposals;
            this.openNewProposalModal(content);
          },
          error: () => this.errorMsg(this.translateService.instant('t-error-creating'))
        });
      },
      error: () => this.errorMsg(this.translateService.instant('t-error-creating'))
    });
  }

  private openNewProposalModal(content: any) {
    this.proposalForm = this.formBuilder.group({
      propertyId: [this.property?.id, [Validators.required]],
      lead: [null],
      contact: [null],
      agencyProposal: [false],
      partnerName: [null],
      licenseImo: [null],
      saleDivision: [50],
      // clientName: [null, Validators.required],
      clientName: [null],
      proposalDate: [new Date()],
      value: [this.property?.price, [Validators.required, Validators.min(1)]],
      obs: [null],
      file: [null]
    });
    this.modalService.open(content, { size: 'md', centered: true, backdropClass: 'custom-modal' });
  }

  private loadPendingProposalsLimit() {
    this.entityService.getEntityForProposal().subscribe({
      next: (entity) => {
        this.pendingProposalsLimit = entity?.pendingProposalsLimit ?? null;
        this.entityTimezone = entity?.timezone ?? null;
      },
    });
  }

  private getActiveProposalsCount(proposals: any[]) {
    return (proposals ?? []).filter((proposal) => !this.isCancelledProposal(proposal)).length;
  }

  private isCancelledProposal(proposal: any) {
    const status = this.getCurrentProposalStatus(proposal);
    return ['declined', 'canceled', 'cancelled', 'recusad', 'cancelad'].some((value) => status.includes(value));
  }

  private getCurrentProposalStatus(proposal: any) {
    return String(
      proposal?.lastAction?.originalStatus ??
      proposal?.history?.[0]?.originalStatus ??
      proposal?.lastAction?.proposalStatus ??
      proposal?.history?.[0]?.proposalStatus ??
      ''
    ).toLowerCase();
  }

  getProposalStatusLabel(status: any): string {
    const translateKey = this.getProposalStatusTranslationKey(status);
    return translateKey ?? status?.proposalStatus ?? '';
  }

  private getProposalStatusTranslationKey(status: any): string | null {
    const normalizedStatus = String(
      status?.proposalStatusCode ??
      status?.originalStatus ??
      status?.proposalStatus ??
      ''
    ).trim().toLowerCase();

    if (!normalizedStatus) {
      return null;
    }

    if (normalizedStatus === 'reserved' || normalizedStatus.includes('reserv')) {
      return 't-proposals.t-status-reserved';
    }

    if (
      normalizedStatus === 'sale agreement' ||
      normalizedStatus.replace(/\s+/g, '') === 'saleagreement' ||
      normalizedStatus === 'cpcv'
    ) {
      return this.property?.businessTypeId === 2
        ? 't-proposals.t-status-lease-agreement'
        : 't-proposals.t-status-cpcv';
    }

    return null;
  }

  private getLimitReachedMessage() {
    const translateKey = 't-pending-proposals-limit-reached';
    const message = this.translateService.instant(translateKey);
    return message !== translateKey
      ? message
      : this.translateService.instant('t-pending-proposals-limit-reached-fallback');
  }

  changeType(ev: boolean) {
    if (ev) {
      this.proposalForm.controls['partnerName'].setValidators(Validators.required);
      this.proposalForm.controls['licenseImo'].setValidators(Validators.required);
      this.proposalForm.controls['saleDivision'].setValidators(Validators.required);
      this.proposalForm.updateValueAndValidity();
    } else {
      const c1 = this.proposalForm.get('partnerName');
      const c2 = this.proposalForm.get('licenseImo');
      const c3 = this.proposalForm.get('saleDivision');
      c1?.clearValidators();
      c1?.updateValueAndValidity();
      c2?.clearValidators();
      c2?.updateValueAndValidity();
      c3?.clearValidators();
      c3?.updateValueAndValidity();
    }
  }

  submitNewProposal() {
    this.submited = true;
    if (this.proposalForm.valid) {
      let formData = new FormData();
      // formData.append('data', JSON.stringify(fData));
      formData.append('clientName', this.proposalForm.get('clientName')?.value);
      // FormData converte null/undefined nas strings "null"/"undefined", que o
      // back-end tenta ler como UUID. Sem imovel nao ha proposta possivel.
      const propertyId = this.proposalForm.get('propertyId')?.value;
      if (!propertyId) {
        this.submited = false;
        this.errorMsg(this.translateService.instant('t-error-creating'));
        return;
      }
      formData.append('propertyId', propertyId);
      formData.append('value', this.proposalForm.get('value')?.value);
      formData.append('proposalDate', this.proposalForm.get('proposalDate')?.value);
      if (this.proposalForm.get('lead')?.value)
        formData.append('lead', this.proposalForm.get('lead')?.value);
      if (this.proposalForm.get('contact')?.value)
        formData.append('contact', this.proposalForm.get('contact')?.value);

      if (this.proposalForm.get('obs')?.value)
        formData.append('obs', this.proposalForm.get('obs')?.value);

      if (this.proposalForm.get('file')?.value)
        formData.append('file', this.proposalForm.get('file')?.value);

      if (this.proposalForm.get('agencyProposal')?.value) {
        formData.append('agencyProposal', this.proposalForm.get('agencyProposal')?.value);
        formData.append('partnerName', this.proposalForm.get('partnerName')?.value);
        formData.append('licenseImo', this.proposalForm.get('licenseImo')?.value);
        formData.append('saleDivision', this.proposalForm.get('saleDivision')?.value);
      }

      this.proposalsService.createProposal(formData).subscribe({
        next: (data) => {
          this.submited = false;
          this.propertyProposalsData.unshift(data);
          this.eventService.broadcast('update-proposals', this.propertyProposalsData);
          document.getElementById('proposal-dismiss-btn')?.click();
          this.showAlertSuccess(this.translateService.instant('t-proposal-created'));
        },
        error: (err) => {
          if (this.isPendingProposalLimitError(err)) {
            this.proposalLimitMsg(this.getLimitReachedMessage());
            return;
          }
          const translated = this.getTranslatedErrorMessage(err);
          this.errorMsg(
            translated ?? this.translateService.instant('t-error-creating')
          );
        }
      });

    }
  }

  /**
   * O filtro global de exceções aninha as respostas de HttpException:
   * `{ message: { statusCode, message: '<chave i18n>', error } }`. Quando a
   * mensagem é uma chave t-... com tradução, mostra-a em vez do erro genérico.
   */
  private getTranslatedErrorMessage(error: any): string | null {
    const payload = error?.error?.message;
    const key =
      typeof payload === 'string' ? payload : payload?.message;
    if (typeof key !== 'string' || !key.startsWith('t-')) {
      return null;
    }
    const translated = this.translateService.instant(key);
    return translated && translated !== key ? translated : null;
  }

  private isPendingProposalLimitError(error: any): boolean {
    const messages = this.extractErrorMessages(error);
    return messages.some((message) => {
      const normalized = String(message ?? '').trim();
      return normalized === 'Property does not accept more proposals'
        || normalized.includes('Property does not accept more proposals');
    });
  }

  private extractErrorMessages(error: any): string[] {
    if (error === null || error === undefined) return [];

    if (typeof error === 'string') {
      return [error];
    }

    if (Array.isArray(error)) {
      return error.flatMap((item) => this.extractErrorMessages(item));
    }

    if (typeof error === 'object') {
      if ('message' in error) {
        return this.extractErrorMessages((error as any).message);
      }
      if ('error' in error) {
        return this.extractErrorMessages((error as any).error);
      }
    }

    return [String(error)];
  }

  addFileCostumer() {
    const inputFile = document.getElementById('input-filec');
    inputFile?.click();
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.proposalForm.patchValue({
        file: file
      });
    }
    event.target.value = '';
  }


  addContact(data: ContactModel) {
    this.contactSelected = data;
    this.clientNameBkp = this.proposalForm.controls['clientName'].value;
    this.proposalForm.patchValue({ contact: data.id, clientName: data.firstName && data?.lastName ? data.firstName + ' ' + data.lastName : data.firstName });
  }

  removeContact() {
    this.contactSelected = null;
    this.proposalForm.patchValue({ contact: null, clientName: this.clientNameBkp ? this.clientNameBkp : null });
    this.clientNameBkp = null;
  }

  openContacts(content: any) {
    this.modalService.open(content, { size: 'md', centered: true, backdropClass: 'custom-modal' });
    this.loadContacts();
  }


  loadLeads() {
    this.noresultLeads = false;
    this.leads = [];
    const subscriptiongetAllCostumers = this.leadsService.getLeadsByProperty(this.property?.id, this.page)
      .pipe(
        tap(data => this.totalLeads = data.total),
        map(data => data.leads),
        tap(() => this.paginateLeads()),
        tap(() => this.noresultLeads = false)
      ).subscribe(leads => {
        this.leads = leads;
        if (this.totalLeads === 0) {
          this.noresultLeads = true;
        }

      });
    this.subscription.add(subscriptiongetAllCostumers);
  }

  addLead(data: LeadsModel) {
    this.leadSelected = data;
    this.proposalForm.patchValue({ lead: data.id });
  }

  removeLead() {
    this.leadSelected = null;
    this.proposalForm.patchValue({ lead: null });
  }

  openLeads(content: any) {
    this.modalService.open(content, { size: 'md', centered: true, backdropClass: 'custom-modal' });
    this.loadLeads();
  }

  loadContacts() {
    this.noresult = false;
    this.contacts = [];
    const subscriptiongetAllCostumers = this.contactsService.getAllCostumersWithOutProperty(this.property?.id, this.page, this.filter, [], [])
      .pipe(
        tap(data => this.total = data.total),
        map(data => data.costumers),
        tap(() => this.paginate()),
        tap(() => this.noresult = false)
      ).subscribe(costumers => {
        this.contacts = costumers;
        if (this.total === 0) {
          this.noresult = true;
        }
      });
    this.subscription.add(subscriptiongetAllCostumers);
  }

  deleteFile() {
    this.proposalForm.patchValue({
      file: null
    });
  }

  clearForm() {
    this.proposalForm = this.formBuilder.group({
      propertyId: [this.property?.id, [Validators.required]],
      lead: [null],
      contact: [null],
      // clientName: [null, [Validators.required]],
      clientName: [null],
      proposalDate: [new Date()],
      value: [this.property?.price, [Validators.required]],
      obs: [null],
      file: [null]
    });
  }

  /**
  * paginate
  */
  paginate() {
    this.startIndex = (this.page - 1) * this.pageSize + 1;
    this.endIndex = (this.page - 1) * this.pageSize + this.pageSize;
    if (this.endIndex > this.total) {
      this.endIndex = this.total;
    }
  }

  /**
  * paginate
  */
  paginateLeads() {
    this.startIndexLeads = (this.pageLeads - 1) * this.pageSizeLeads + 1;
    this.endIndexLeads = (this.pageLeads - 1) * this.pageSizeLeads + this.pageSizeLeads;
    if (this.endIndexLeads > this.totalLeads) {
      this.endIndexLeads = this.totalLeads;
    }
  }

  /**
   * Counter Proposal
   */


  counterProposal(content: any, proposal: ProposalModel) {
    this.initCounterForm(proposal);
    this.modalService.open(content, { size: 'md', centered: true, backdropClass: 'custom-modal' });
  }

  initCounterForm(proposal: ProposalModel) {
    this.counterProposalForm = this.formBuilder.group({
      proposalId: [proposal.id],
      clientName: [proposal.clientName],
      value: [null, [Validators.required, Validators.min(1)]],
      obs: [null],
      file: [null]
    });
    if (proposal.agencyProposal) {
      const lastVal = proposal.lastAction ? proposal.lastAction.saleDivision : proposal.firstProposal ? proposal.firstProposal.saleDivision : 50;
      this.counterProposalForm.setControl('saleDivision', new FormControl(lastVal, [Validators.required]))
    }
  }

  get formCounter() {
    return this.counterProposalForm.controls;
  }

  submitCounterProposal() {
    this.submitedCounter = true;
    if (this.counterProposalForm.valid) {
      let formData = new FormData();
      const proposalId = this.counterProposalForm.get('proposalId')?.value;
      // formData.append('data', JSON.stringify(fData));
      formData.append('value', this.counterProposalForm.get('value')?.value);

      if (this.counterProposalForm.get('obs')?.value)
        formData.append('obs', this.counterProposalForm.get('obs')?.value);

      if (this.counterProposalForm.get('file')?.value)
        formData.append('file', this.counterProposalForm.get('file')?.value);

      if (this.counterProposalForm.get('saleDivision')?.value)
        formData.append('saleDivision', this.counterProposalForm.get('saleDivision')?.value)

      this.proposalsService.counterProposal(proposalId, formData).subscribe({
        next: (data: ProposalModel) => {
          this.submitedCounter = false;
          document.getElementById('proposal-dismiss-btn')?.click();
          const find = this.propertyProposalsData.find(p => p.id === proposalId);
          if (find && data.history) {
            find?.history?.unshift(data?.history[0]);
            find.lastAction = data?.history[0];
          }
          this.eventService.broadcast('update-proposals', this.propertyProposalsData);
          // const findBkp = this.bkpList.find(p => p.id === proposalId);
          // if (findBkp && data.history) {
          //   findBkp?.history?.unshift(data?.history[0]);
          //   findBkp.lastAction = data?.history[0];
          // }
        },
        error: (err) => {
          this.errorMsg(this.translateService.instant('t-error-creating'));
        }
      });

    }
  }

  clearFormCounter() {
    this.counterProposalForm.reset();
  }

  onFileChangeCounter(event: any) {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.counterProposalForm.patchValue({
        file: file
      });
    }
    event.target.value = '';
  }

  deleteFileCounter() {
    this.counterProposalForm.patchValue({
      file: null
    });
  }

  /**
   * Refuse Proposal
   */

  /** "Obs", "Motivo da recusa" ou "Motivo do cancelamento", conforme a entrada. */
  obsLabelKey(entry: any, history: any[] | null | undefined): string {
    return proposalHistoryObsLabelKey(entry, history);
  }

  /**
   * O motivo (opcional) fica no histórico da proposta. `afterAcceptance`: o
   * botão diz "Cancelar" (proposta já aceite) e os textos são os de cancelar.
   */
  refuseProposal(proposalId: any, value: any, afterAcceptance = false) {
    Swal.fire({
      title: this.translateService.instant(afterAcceptance ? 't-proposals.t-cancel-title' : 't-proposals.t-refuse-title'),
      text: this.translateService.instant('t-proposals.t-refuse-text'),
      icon: 'warning',
      input: 'textarea',
      inputLabel: this.translateService.instant(afterAcceptance ? 't-proposals.t-cancel-reason' : 't-proposals.t-refuse-reason'),
      inputPlaceholder: this.translateService.instant(afterAcceptance ? 't-proposals.t-cancel-reason' : 't-proposals.t-refuse-reason'),
      showCancelButton: true,
      confirmButtonColor: '#008a00',
      cancelButtonColor: '#f46a6a',
      confirmButtonText: this.translateService.instant(afterAcceptance ? 't-proposals.t-cancel-confirm' : 't-proposals.t-refuse-confirm'),
      cancelButtonText: this.translateService.instant('t-proposals.t-refuse-cancel')
    }).then(result => {
      // Com input, `value` é o texto: vazio sem motivo, mas confirmado.
      if (result.isConfirmed) {
        const reason = `${result.value ?? ''}`.trim();
        this.proposalsService.declineProposal(proposalId, value, reason).subscribe({
          next: (data: { proposal: ProposalModel, status: boolean | number }) => {
            if (data?.proposal.history) {
              const find = this.propertyProposalsData.find(p => p.id === proposalId);
              if (find) {
                find?.history?.unshift(data?.proposal?.history[0]);
                find.lastAction = data?.proposal?.history[0];
              }
              this.eventService.broadcast('update-proposals', this.propertyProposalsData);
            }
            if (data?.status !== false && !isNaN(Number(data?.status))) {
              if (this.detailsForm) {
                this.detailsForm.data.businessStatus = Number(data.status);
                this.eventService.broadcast('can-change-business-status', true);
              }
            }
          },
          error: (err) => {
            this.errorMsg(this.translateService.instant('t-error-creating'));
          }
        })
      }
    });
  }

  /**
   * Delete Proposal
   */


  deleteProposal(id: any) {
    Swal.fire({
      title: this.translateService.instant('t-proposals.t-delete-title'),
      text: this.translateService.instant('t-proposals.t-delete-text'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#008a00',
      cancelButtonColor: '#f46a6a',
      confirmButtonText: this.translateService.instant('t-proposals.t-delete-confirm'),
      cancelButtonText: this.translateService.instant('t-proposals.t-delete-cancel')
    }).then(result => {
      if (result.value) {
        this.proposalsService.deleteProposal(id).subscribe({
          next: (data: { status?: boolean | number }) => {
            this.proposalSelected = null;
            this.propertyProposalsData = this.propertyProposalsData.filter(p => p.id !== id);
            this.bkpList = this.bkpList.filter(p => p.id !== id);
            this.eventService.broadcast('update-proposals', this.propertyProposalsData);
            if (data.status !== false && !isNaN(Number(data.status))) {
              this.detailsForm.data.businessStatus = Number(data.status);
              this.eventService.broadcast('can-change-business-status', true);
            }
          },
          error: (err) => {
            this.errorMsg(this.translateService.instant('t-delete-error'));
          }
        })
      }
    });
  }

  /**
   * Accept proposal
   */
  acceptProposal(proposalId: any, value: any) {
    Swal.fire({
      title: this.translateService.instant('t-proposals.t-accept-title'),
      text: this.translateService.instant('t-proposals.t-accept-text'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#008a00',
      cancelButtonColor: '#f46a6a',
      confirmButtonText: this.translateService.instant('t-proposals.t-accept-confirm'),
      cancelButtonText: this.translateService.instant('t-proposals.t-accept-cancel')
    }).then(result => {
      if (result.value) {
        this.proposalsService.acceptProposal(proposalId, value).subscribe({
          next: (data: { proposal: ProposalModel, reservedId: any }) => {
            if (data?.proposal?.history) {
              const find = this.propertyProposalsData.find(p => p.id === proposalId);
              if (find) {
                find?.history?.unshift(data.proposal?.history[0]);
                find.lastAction = data.proposal?.history[0];
              }
              this.eventService.broadcast('update-proposals', this.propertyProposalsData);
              // const findBkp = this.bkpList.find(p => p.id === proposalId);
              // if (findBkp) {
              //   findBkp?.history?.unshift(data.proposal?.history[0]);
              //   findBkp.lastAction = data.proposal?.history[0];
              // }
            }
            if (data?.reservedId) {
              if (this.detailsForm) {
                this.detailsForm.data.businessStatus = data.reservedId;
                this.eventService.broadcast('can-change-business-status', false);
              }
            }
          },
          error: (err) => {
            this.errorMsg(this.translateService.instant('t-error-creating'));
          }
        })
      }
    });
  }

  onProposalChecked(event: any) {
    const { proposalId, proposal } = event;
    const listingAgents = Array.isArray(event?.listingAgents)
      ? event.listingAgents
      : [];
    const sellingAgents = Array.isArray(event?.sellingAgents)
      ? event.sellingAgents
      : [];
    if (proposal?.history) {
      const find = this.propertyProposalsData.find(p => p.id === proposalId);
      if (find) {
        find?.history?.unshift(proposal.history[0]);
        find.lastAction = proposal.history[0];
      }
      this.eventService.broadcast('update-proposals', this.propertyProposalsData);
    }
    if (event?.saleId && this.detailsForm) {
      this.detailsForm.data.businessStatus = event.saleId;
      this.detailsForm.data.saleValue = event.formValues?.saleValue;
      this.detailsForm.data.saleDate = event.formValues?.saleDate;
      this.detailsForm.data.isPercentageCommission = event.formValues?.isPercentageCommission;
      this.detailsForm.data.saleCommission = event.formValues?.saleCommission;
      if (event.formValues?.agencyProposal) {
        this.detailsForm.data.splitCommissionValue = event.formValues?.splitCommissionValue;
        this.detailsForm.data.partnerEntityName = event.formValues?.partnerName;
        this.detailsForm.data.sharedSale = true;
        this.detailsForm.data.sharedCommission = event.formValues?.saleDivision
          ? (100 - Number(event.formValues.saleDivision)) : null;
      }
      this.eventService.broadcast('can-change-business-status', false);
    }

    // Re-sync selected listing/selling agents from modal result.
    this.agents = (this.agents ?? []).map((agent: any) => ({
      ...agent,
      isListingAgent: false,
      isSellingAgent: false,
    }));

    listingAgents.forEach((listing: any) => {
      const existing = this.agents.find((agent: any) => agent.id === listing.id);
      if (existing) {
        existing.isListingAgent = true;
      } else {
        this.agents.push({ ...listing, isListingAgent: true, isSellingAgent: false });
      }
    });

    sellingAgents.forEach((selling: any) => {
      const existing = this.agents.find((agent: any) => agent.id === selling.id);
      if (existing) {
        existing.isSellingAgent = true;
      } else {
        this.agents.push({ ...selling, isListingAgent: false, isSellingAgent: true });
      }
    });

    this.eventService.broadcast('data-tab-agents', this.agents);
  }

  /**
   * Utilities
   */

  getDate(date: Date) {
    date = new Date(date);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  changeProposalSelected(proposal: ProposalModel) {
    if (this.proposalSelected && proposal.id === this.proposalSelected.id) {
      this.proposalSelected = null;
    } else {
      this.proposalSelected = proposal;
    }
  }

  formatSizeUnits(bytes: any) {
    if (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
    else if (bytes >= 1048576) { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
    else if (bytes >= 1024) { bytes = (bytes / 1024).toFixed(2) + " KB"; }
    else if (bytes > 1) { bytes = bytes + " bytes"; }
    else if (bytes == 1) { bytes = bytes + " byte"; }
    else { bytes = "0 bytes"; }
    return bytes;
  }


  getIconColor(icon: any) {
    if (icon) {
      switch (icon) {
        case 'ri-close-circle-line':
          return 'bg-danger'
        case 'ri-check-double-line':
          return 'bg-success'
        case 'ri-trophy-line':
          return 'bg-gold'
        default:
          return 'bg-light text-success'
      }
    }
    return 'bg-light text-success';
  }

  getBadge(icon: any) {
    if (icon) {
      switch (icon) {
        case 'ri-close-circle-line':
          return 'badge-soft-danger'
        case 'ri-check-double-line':
          return 'badge-soft-success'
        case 'ri-trophy-line':
          return 'badge-soft-gold'
        default:
          return 'badge-soft-info'
      }
    }
    return 'badge-soft-info';
  }

  priceFormat(propertyPrice: any) {
    if (propertyPrice) {
      let price = propertyPrice.toString().split('.');
      const spaces = (price: any) =>
        String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, ' ');
      const price1 = spaces(price[0]);
      if (price.length > 1) return price1 + ',' + price[1];

      return price1;
    } return propertyPrice;
  }

  /** Fração de empreendimento (ligação direta ou pelo bloco): só aí há "Enviar para o promotor". */
  get isDevelopmentFraction(): boolean {
    return !!(this.detailsForm?.data?.associatedProperty || this.property?.associatedPropertyId || this.property?.blockId);
  }

  canSendToPromoter(history: any): boolean {
    return (
      this.isDevelopmentFraction &&
      PROMOTER_EMAIL_OPEN_STATUSES.includes(history?.proposalStatusCode) &&
      !this.proposalSelected?.history?.some((h: any) => h?.proposalStatusCode === PROMOTER_UNDER_ANALYSIS_STATUS)
    );
  }

  openSendToPromoter(proposalId: any) {
    const modalRef = this.modalService.open(SendToPromoterModalComponent, { size: 'lg', centered: true, scrollable: true });
    modalRef.componentInstance.proposalId = proposalId;
    // Enviada → "Em Análise": a entrada nova entra no histórico como numa contraproposta.
    // Com "Reservar o imóvel", a fração passa a Reservado (como no Aceitar).
    modalRef.result.then((result: any) => {
      if (!result?.history && !result?.reservedId) return;
      if (result.history) {
        const find = this.propertyProposalsData.find(p => p.id === proposalId);
        const targets = [find, this.proposalSelected?.id === proposalId ? this.proposalSelected : null]
          .filter((target, index, list) => !!target && list.indexOf(target) === index);
        for (const target of targets as any[]) {
          target?.history?.unshift(result.history);
          target.lastAction = result.history;
        }
        this.eventService.broadcast('update-proposals', this.propertyProposalsData);
      }
      if (result.reservedId && this.detailsForm) {
        this.detailsForm.data.businessStatus = result.reservedId;
        this.eventService.broadcast('can-change-business-status', false);
      }
    }, () => undefined);
  }

  generateProposalRef(id: any) {
    if (id) {
      const ref = id.toString().padStart(4, '0');
      return `#P${ref}`;
    } else {
      return ``;
    }
  }

  private hasProposalValue(value: any) {
    return value !== null && value !== undefined && value !== '';
  }

  getAdditionalProposalDetails(proposal: ProposalModel | null | undefined) {
    if (!proposal) return [];
    const cacheKey = proposal as object;
    const cached = this.proposalDetailsCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const details = [
      { label: this.translateService.instant('t-proposals.t-details-client'), value: proposal.clientName },
      { label: this.translateService.instant('t-proposals.t-details-license-ami-imo'), value: proposal.licenseImo },
      { label: this.translateService.instant('t-proposals.t-details-bank'), value: proposal.bank },
      { label: this.translateService.instant('t-proposals.t-details-financing'), value: proposal.financing },
      { label: this.translateService.instant('t-proposals.t-details-source-funds'), value: proposal.sourceFunds },
      { label: this.translateService.instant('t-proposals.t-details-cpcv-term'), value: proposal.promiseContractTime },
      { label: this.translateService.instant('t-proposals.t-details-signal-1'), value: this.formatSignalDetail(proposal.signalBooster, proposal.signalBoosterPercent) },
      { label: this.translateService.instant('t-proposals.t-details-signal-2'), value: this.formatSignalDetail(proposal.signalBooster2, proposal.signalBooster2Percent) },
      { label: this.translateService.instant('t-proposals.t-details-signal-3'), value: this.formatSignalDetail(proposal.signalBooster3, proposal.signalBooster3Percent) },
      { label: this.translateService.instant('t-proposals.t-details-signal-4'), value: this.formatSignalDetail(proposal.signalBooster4, proposal.signalBooster4Percent) },
      { label: this.translateService.instant('t-proposals.t-details-purpose'), value: this.formatProposalPurpose(proposal.purpose) },
      { label: this.translateService.instant('t-proposals.t-details-reserve-value'), value: this.formatFinancialDetail(proposal.reserveValue) },
      { label: this.translateService.instant('t-proposals.t-details-payment-method'), value: this.formatPaymentMethod(proposal.paymentMethod) },
      { label: this.translateService.instant('t-proposals.t-details-deed-term'), value: proposal.deedTime },
      { label: this.translateService.instant('t-proposals.t-details-start-date'), value: proposal.startDate ? this.getDate(proposal.startDate as any) : null },
      { label: this.translateService.instant('t-proposals.t-details-security-deposit'), value: this.formatFinancialDetail(proposal.securityDeposit) },
      { label: this.translateService.instant('t-proposals.t-details-contract-duration'), value: proposal.contractDuration },
      { label: this.translateService.instant('t-proposals.t-details-contract-renewal'), value: proposal.renewalDuration },
      { label: this.translateService.instant('t-proposals.t-details-mediation-store'), value: proposal.mediationStore },
      { label: this.translateService.instant('t-proposals.t-details-responsible'), value: proposal.responsible },
      { label: this.translateService.instant('t-proposals.t-details-partner-agency'), value: proposal.partnerEntityName },
    ];

    const filteredDetails = details.filter((item) => this.hasProposalValue(item.value));
    this.proposalDetailsCache.set(cacheKey, filteredDetails);
    return filteredDetails;
  }

  getProposalProposers(proposal: ProposalModel | null | undefined): any[] {
    if (!proposal) {
      return [];
    }
    const cacheKey = proposal as object;
    const cached = this.proposalProposersCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const proposers = (proposal as any)?.proposalProposers;
    const normalized = Array.isArray(proposers) ? proposers : [];
    this.proposalProposersCache.set(cacheKey, normalized);
    return normalized;
  }

  getProposalProposerName(proposer: any) {
    const contactName = [proposer?.contact?.firstName, proposer?.contact?.lastName]
      .filter(Boolean)
      .join(' ')
      .trim();

    return proposer?.name || proposer?.contact?.fullName || contactName || proposer?.company || '-';
  }

  getProposalProposerIdentifier(proposer: any) {
    return proposer?.fiscalIdentification ?? proposer?.companyFiscalIdentification ?? null;
  }

  getProposalProposerTypeLabel(proposer: any) {
    const proposerTypeMap: Record<string, string> = {
      LEGAL: 't-proposals.t-proposer-type-legal',
      EFFECTIVE_BENEFICIARY: 't-proposals.t-proposer-type-effective-beneficiary',
      FIATHER: 't-proposals.t-proposer-type-fiather',
      INDIVIDUAL: 't-proposals.t-proposer-type-individual',
    };
    const translationKey = proposerTypeMap[String(proposer?.type ?? '').toUpperCase()];
    if (!translationKey) return null;
    return this.getSafeLabel(translationKey, null);
  }

  private getSafeLabel(key: string, fallback: string | null = key) {
    const label = this.translateService.instant(key);
    if (!label || label === key || label.includes('?')) {
      return fallback;
    }
    return label;
  }

  private formatProposalPurpose(value: any) {
    const purposeMap: Record<string, string> = {
      PERMANENT: 't-proposals.t-purpose-permanent',
      SECONDARY: 't-proposals.t-purpose-secondary',
      INVESTMENT: 't-proposals.t-purpose-investment',
    };
    const translationKey = purposeMap[String(value ?? '').toUpperCase()];
    if (!translationKey) return value;
    return this.getSafeLabel(translationKey, value);
  }

  private formatPaymentMethod(value: any) {
    const paymentMethodMap: Record<string, string> = {
      CASH: 't-proposals.t-payment-method-cash',
      CHECK_REAL: 't-proposals.t-payment-method-check-real',
      CHECK_OWNER: 't-proposals.t-payment-method-check-owner',
      TRANSFER_REAL: 't-proposals.t-payment-method-transfer-real',
      TRANSFER_OWNER: 't-proposals.t-payment-method-transfer-owner',
    };
    const translationKey = paymentMethodMap[String(value ?? '').toUpperCase()];
    if (!translationKey) return value;
    return this.getSafeLabel(translationKey, value);
  }

  private formatSignalDetail(value: any, isPercent: any) {
    const percent = isPercent === true || `${isPercent}` === 'true';
    const num = Number(value);
    if (
      percent &&
      value !== null &&
      value !== undefined &&
      value !== '' &&
      !Number.isNaN(num) &&
      num !== 0
    ) {
      return `${value}%`;
    }
    return this.formatFinancialDetail(value);
  }

  private formatFinancialDetail(value: any) {
    const numericValue = this.parseNumericValue(value);
    if (numericValue === null) {
      return this.hasProposalValue(value) ? value : null;
    }

    if (numericValue === 0) {
      return null;
    }

    return `${this.priceFormat(numericValue)} €`;
  }

  private parseNumericValue(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    if (typeof value !== 'string') {
      return null;
    }

    let normalized = value.trim().replace(/\s/g, '');
    if (!normalized) {
      return null;
    }

    const hasComma = normalized.includes(',');
    const hasDot = normalized.includes('.');

    if (hasComma && hasDot) {
      if (normalized.lastIndexOf(',') > normalized.lastIndexOf('.')) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = normalized.replace(/,/g, '');
      }
    } else if (hasComma) {
      normalized = normalized.replace(',', '.');
    }

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }

  private clearProposalDetailsCache() {
    this.proposalDetailsCache = new WeakMap<object, Array<{ label: string; value: any }>>();
    this.proposalProposersCache = new WeakMap<object, any[]>();
  }


  /**
* show sweet alert success
* @param position modal content
*/
  showAlertSuccess(msg: string) {
    Swal.fire({
      //position: 'top-end',
      icon: 'success',
      title: msg,
      showConfirmButton: false,
      timer: 1500,
    });
  }

  /**
* Title sweet alert
* @param Error Msg modal content
*/
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: this.translateService.instant('t-something-wrong'),
      text: errorMsg,
      icon: 'warning',
      confirmButtonColor: 'rgb(54, 69, 116)',
      confirmButtonText: this.translateService.instant('t-close')
    });
  }

    /**
  * Title sweet alert
  * @param Error Msg modal content
  */
    proposalLimitMsg(errorMsg: string) {
      Swal.fire({
        title: errorMsg,
        text: '',
        icon: 'info',
        confirmButtonColor: 'rgb(54, 69, 116)',
        confirmButtonText: this.translateService.instant('t-close')
      });
    }

  ngOnDestroy(): void {
    clearTimeout(this.proposalsWindowTimer);
    this.subscription.unsubscribe();
  }

}
